/** 1-based place of this page among the form's pages, in page order. */
export function formPagePosition(pageIndexes: number[], pageIndex: number): number {
    const ordered = [...pageIndexes].sort((a, b) => a - b);
    const found = ordered.indexOf(pageIndex);
    return found >= 0 ? found + 1 : 1;
}

/**
 * Fill for the page progress bar. Page 1 is empty. The last page is still short
 * of 100, which is only reached once the form is submitted.
 */
export function formPageProgressPercent(position: number, pageTotal: number): number {
    if (pageTotal <= 1) return 0;
    const clamped = Math.min(Math.max(position, 1), pageTotal);
    return Math.round(((clamped - 1) / pageTotal) * 100);
}
